// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 문의사항 관리 - 사용자관리 디자인 기준 */
.qm-page {
  width: 100%;
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}
.qm-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.qna-management-layout .qm-heading h2 {
  position: relative;
  margin: 0 0 6px;
  padding: 0 0 15px;
  border-bottom: 1px solid #9f9f9f;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
}
.qm-heading p {
  margin: 0;
  color: #8190a2;
  font-size: 13px;
}
.qm-total {
  padding: 9px 13px;
  border-radius: 7px;
  background: #eaf3ff;
  color: #1671d8;
  font-size: 13px;
  font-weight: 700;
}
.qm-panel {
  padding: 22px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 9px #1e375a10;
}
.qm-filter {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 260px;
  font-size: 13px;
  font-weight: 700;
}
.qm-filter select {
  height: 41px;
  padding: 0 12px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  color: #34465b;
}
.qm-search {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}
.qm-search input {
  flex: 1 1;
  min-width: 0;
  height: 41px;
  padding: 0 12px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  font-size: 13px;
}
.qm-search button, .qm-pagination button {
  padding: 8px 16px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  color: #34465b;
  cursor: pointer;
}
.qm-table-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin: 25px 0 12px;
  font-size: 14px;
}
.qm-table-top span {
  font-size: 12px;
  color: #8a98a8;
}
.qm-table-wrap {
  width: 100%;
  overflow-x: auto;
}
.qm-table {
  width: 100%;
  min-width: 850px;
  border-collapse: collapse;
  text-align: center;
  font-size: 15px;
  line-height: 15px;
}
.qm-table th {
  padding: 12px 9px;
  border-top: 2px solid #2196f3;
  background: #f1f5fa;
  color: #3b4c62;
  font-size: 15px;
  font-weight: 700;
}
.qm-table td {
  height: 48px;
  padding: 10px 9px;
  box-sizing: border-box;
  border-bottom: 1px solid #e8edf3;
  font-size: 15px;
  font-weight: 400;
}
.qm-table tbody tr {
  cursor: pointer;
}
.qm-table tbody tr:hover,
.qm-table tbody tr:focus {
  background: #f1f8ff;
  outline: none;
}
.qm-title {
  text-align: left;
}
.qm-replied, .qm-pending {
  display: inline-block;
  padding: 5px 9px;
  border-radius: 4px;
  font-weight: 700;
  white-space: nowrap;
}
.qm-replied {
  background: #e2f8ed;
  color: #13884d;
}
.qm-pending {
  background: #edf0f4;
  color: #78818e;
}
.qm-empty {
  padding: 45px 9px !important;
  color: #8a98a8;
}
.qm-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  color: #8090a1;
  font-size: 12px;
}
.qm-pagination {
  display: flex;
  align-items: center;
  gap: 5px;
}
.qm-pagination button {
  padding: 7px 10px;
  font-size: 12px;
}
.qm-pagination button.active {
  background: #168ff0;
  border-color: #168ff0;
  color: #fff;
}
.qm-pagination button:disabled {
  opacity: .35;
  cursor: not-allowed;
}
@media (max-width: 900px) {
  .qm-table-top { flex-wrap: wrap; }
  .qm-footer { flex-direction: column; align-items: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/components/qna/AdminQnaRedesign.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,WAAW;EACX,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB,eAAe,EAAE;EACjC,aAAa,sBAAsB,EAAE,uBAAuB,EAAE;AAChE","sourcesContent":["/* 문의사항 관리 - 사용자관리 디자인 기준 */\n.qm-page {\n  width: 100%;\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n.qm-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n.qna-management-layout .qm-heading h2 {\n  position: relative;\n  margin: 0 0 6px;\n  padding: 0 0 15px;\n  border-bottom: 1px solid #9f9f9f;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.qm-heading p {\n  margin: 0;\n  color: #8190a2;\n  font-size: 13px;\n}\n.qm-total {\n  padding: 9px 13px;\n  border-radius: 7px;\n  background: #eaf3ff;\n  color: #1671d8;\n  font-size: 13px;\n  font-weight: 700;\n}\n.qm-panel {\n  padding: 22px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 9px #1e375a10;\n}\n.qm-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 260px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.qm-filter select {\n  height: 41px;\n  padding: 0 12px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  color: #34465b;\n}\n.qm-search {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n}\n.qm-search input {\n  flex: 1;\n  min-width: 0;\n  height: 41px;\n  padding: 0 12px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  font-size: 13px;\n}\n.qm-search button, .qm-pagination button {\n  padding: 8px 16px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  color: #34465b;\n  cursor: pointer;\n}\n.qm-table-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin: 25px 0 12px;\n  font-size: 14px;\n}\n.qm-table-top span {\n  font-size: 12px;\n  color: #8a98a8;\n}\n.qm-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n.qm-table {\n  width: 100%;\n  min-width: 850px;\n  border-collapse: collapse;\n  text-align: center;\n  font-size: 15px;\n  line-height: 15px;\n}\n.qm-table th {\n  padding: 12px 9px;\n  border-top: 2px solid #2196f3;\n  background: #f1f5fa;\n  color: #3b4c62;\n  font-size: 15px;\n  font-weight: 700;\n}\n.qm-table td {\n  height: 48px;\n  padding: 10px 9px;\n  box-sizing: border-box;\n  border-bottom: 1px solid #e8edf3;\n  font-size: 15px;\n  font-weight: 400;\n}\n.qm-table tbody tr {\n  cursor: pointer;\n}\n.qm-table tbody tr:hover,\n.qm-table tbody tr:focus {\n  background: #f1f8ff;\n  outline: none;\n}\n.qm-title {\n  text-align: left;\n}\n.qm-replied, .qm-pending {\n  display: inline-block;\n  padding: 5px 9px;\n  border-radius: 4px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.qm-replied {\n  background: #e2f8ed;\n  color: #13884d;\n}\n.qm-pending {\n  background: #edf0f4;\n  color: #78818e;\n}\n.qm-empty {\n  padding: 45px 9px !important;\n  color: #8a98a8;\n}\n.qm-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n  color: #8090a1;\n  font-size: 12px;\n}\n.qm-pagination {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.qm-pagination button {\n  padding: 7px 10px;\n  font-size: 12px;\n}\n.qm-pagination button.active {\n  background: #168ff0;\n  border-color: #168ff0;\n  color: #fff;\n}\n.qm-pagination button:disabled {\n  opacity: .35;\n  cursor: not-allowed;\n}\n@media (max-width: 900px) {\n  .qm-table-top { flex-wrap: wrap; }\n  .qm-footer { flex-direction: column; align-items: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
